<template>
  <pre>{{ cats }}</pre>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ViewApi',
  data() {
    return {
      id: '',
    };
  },
  computed: {
    ...mapGetters({
      cats: 'getAPIData',
    }),
  },

  methods: {},

  beforeMount() {
    /* route urls vm.$route.params
     * :id/get_rec
     * :root_id/:parent_id/get_children
     * :pattern/get_recs
     */

    if (this.$route.name === 'ViewApiGetRecs') {
      this.$store.dispatch('viewGetRecordNames', {
        collection: this.$route.params.collection,
        pattern: this.$route.params.pattern,
      });
    } else if (this.$route.name === 'ViewApiGetRec') {
      this.$store.dispatch('viewGetRecordName', {
        collection: this.$route.params.collection,
        id: this.$route.params.id,
      });
    } else if (this.$route.name === 'ViewApiGetChildren') {
      this.$store.dispatch('viewGetChildren', {
        collection: this.$route.params.collection,
        parent_id: this.$route.params.parent_id,
      });
    } else if (this.$route.name === 'ViewApiGetSiblings') {
      this.$store.dispatch('viewGetSiblings', {
        collection: this.$route.params.collection,
        my_id: this.$route.params.my_id,
      });
    } else if (this.$route.name === 'ViewApiGetParent') {
      this.$store.dispatch('viewGetParent', {
        collection: this.$route.params.collection,
        my_id: this.$route.params.my_id,
      });
    } else if (this.$route.name === 'ViewApiGetParentChildren') {
      this.$store.dispatch('viewGetParentChildren', {
        collection: this.$route.params.collection,
        my_id: this.$route.params.my_id,
      });
    } else if (this.$route.name === 'ViewApiGetWholeRecord') {
      this.$store.dispatch('viewGetWholeRecord', {
        collection: this.$route.params.collection,
        my_id: this.$route.params.my_id,
      });
    }
  },
};
</script>

<style></style>
